import ApiClient from "Store/client";

export const fetchCourseTemplatesByTypeApi = (queryString) =>
  ApiClient<CourseTemplate[]>(`api/course-templates${queryString}`);

export const fetchCourseTemplateSessionsApi = ({ template_id, sessions: body }) =>
  ApiClient(`api/course-templates/${template_id}/schedule`, {
    method: "POST",
    body
  });

export const createCourseTemplateApi = (body: CreateCourseTemplateRequest) =>
  ApiClient(`api/commands/create-course-template`, {
    method: "POST",
    body
  });

export const updateCourseTemplateApi = (body: UpdateCourseTemplateRequest) =>
  ApiClient(`api/commands/update-course-template`, {
    method: "PATCH",
    body
  });

export const applyCourseTemplateToStudentApi = (body) =>
  ApiClient(`api/commands/apply-course-template-to-student`, {
    method: "POST",
    body
  });

export const applyCourseTemplateToClassApi = (body) =>
  ApiClient(`api/commands/apply-course-template-to-classroom`, {
    method: "POST",
    body
  });

export const fetchCourseTemplateApi = (templateId: string) =>
  ApiClient<CourseTemplate>(`api/course-templates/${templateId}?stats=1`);

export const deleteCourseTemplatesApi = (body: DeleteCourseTemplatesRequest) =>
  ApiClient(`api/commands/delete-course-template`, { method: "DELETE", body });
